import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		sections: []
	},

	actions: {
		fetchAll ({ commit }) {
			return window.axios.get('/sections').then(({ data }) => {
				commit(types.STORE_SECTIONS, data)
				return data
			})
		} 
	},

	mutations: {
		[types.STORE_SECTIONS] (state, sections) {
			state.sections = sections
		}
	},

	getters: {}
}
